import { render } from "./howToComponent.vue?vue&type=template&id=40922b3c"
import script from "./howToComponent.vue?vue&type=script&lang=js"
export * from "./howToComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__